module.exports = __webpack_public_path__ + "img/starling_logo.c3247d72.png";